import React from "react";
import { Button, DropdownButton, Dropdown, Form, Tabs, Tab, Modal, ToggleButton, Card } from 'react-bootstrap';
import { Nav, ListGroup } from 'react-bootstrap';
import { context } from '../AppContext';
import DetailScreen from "./DetailScreen";
import Flow from "../flow/Flow";
import LineGraph from "../LineGraph";
import HorizontalTabs from "../HorizontalTabs";
import ItemEditor from "../ItemEditor";
import OrganizationFinder from '../dialogs/organizationFinder';
import SiteFinder from '../dialogs/siteFinder';
import DeviceFinder from '../dialogs/deviceFinder';
import UserFinder from '../dialogs/userFinder';
import NoteEntry from '../items/NoteEntry';
import ConfigHistory from '../dialogs/ConfigHistory';
import ConfigExplorer from "../dialogs/ConfigExplorer";
import StatusList from "./site/StatusList";
import StatusHistory from "./site/StatusHistory";
import StatusGraph from "./site/StatusGraph";
import ConfigRaw from "./site/ConfigRaw";
import ConfigCombined from "./site/ConfigCombined";
import SiteParams from "./site/SiteParams";
import Locale from "../../locale/Locale";
import AlertList from "./site/AlertList";
import HistoryList from "./site/HistoryList";
import HistoryTimeRange from "./components/HistoryTimeRange";

export default class SiteDetails extends DetailScreen {
    pathPrefix = "/sites";
    methodPrefix = "Site";
    methodName = "Professional.getSites";
    uuidFieldName = "siteUuid";
    state = { 
        itemData: null,
        itemConfig: null,
        itemStatus: [],
        itemDesiredState: null,
        itemMetrics: null,
        itemMetricsTime: new Date(),
        itemHistory: [],
        itemHistoryTime: new Date(),
        historyMode: 'all',
        historySource: 'all',
        metricsHours: 12,
        historyHours: 24,
        historySearch: "",
        itemAlertsPage: [],
        itemAlerts: [],
        itemNotes: [],
        historyLoading: false,
        apiHistory: [],
        alertsLoading: false,
        showClosedAlerts: false,
        vpnPing: [],
        chemistry: [],
        scheduleRaw: false,
        themesRaw: false,
        themeMacrossRaw: false,
        itemBowHistoryPage: 0,
        itemBowHistory: null
    }
    updateInterval;
    colors = ["red", "green", "blue"];
    hardwareConfigRef = React.createRef();
    desiredStatesRef = React.createRef();
    newNoteRef = React.createRef();
    heatingStatsRef = React.createRef();
    energyRatesRef = React.createRef();
    chemistryRef = React.createRef();
    paletteRef = React.createRef();
    scheduleConfigRef = React.createRef();
    themesConfigRef = React.createRef();
    buttonMappingsRef = React.createRef();

    componentDidMount() {
        super.componentDidMount();
        //this.updateInterval = setInterval(this.updateStatus.bind(this), 5000);
        context.on('updateStates', (req) => {
            //console.log('UPDATESTATES', req);
            if (this.state.itemData?.id === req.siteId) {
                //this.setState({ itemStatus: req.state });
            }
        });
    }

    componentWillUnmount() {
        clearInterval(this.updateInterval);
    }

    checkload() {
        if (this.state.itemData === false) {
            const match = context.matchPath(this.pathPrefix);
            return ( "Item with UUID " + match.params.recordId + " not found" );
        } else if (!this.state.itemData || !this.state.itemConfig) {
            return ( "Loading..." );
        }
        return true;
    }

    async updateNotes() {
        this.setState({ 
            itemNotes: null
        });
        let itemNotes = await context.makeRequest("Admin.getNotes", {
            siteId: this.state.itemData.id
        });
        if (itemNotes.result)
            this.setState({ 
                itemNotes: itemNotes.result.items
            });
    }

    async updateBowHistory(hours) {
        this.setState({ updatingBowHistory: true });
        let bowHistory = await context.makeRequest("Admin.getBowHistory", {
            siteId: this.state.itemData.id,
            page: this.state.itemBowHistoryPage || 0,
            pageSize: 100
        });
        /*console.log({
            siteId: this.state.itemData.id
        }, itemAlerts);*/
        this.setState({ 
            itemBowHistory: bowHistory.result?.items || [],
            itemBowHistoryCount: bowHistory.result?.totalItemCount || 0,
            updatingBowHistory: false
        });
    }

    async updateHistory(hours) {
        this.setState({ historyLoading: true });
        let filters = [];
        if (this.state.itemConfig) {
            filters.push({ 
                key: 'Device', 
                value: [
                    ...(this.state.itemConfig.Devices.filter(dev => dev.DeviceType === "Thermistor").map(dev => dev.UUID)),
                    ...(this.state.itemConfig.BodiesOfWater.map(dev => dev.UUID)),
                ]
            });
        }

        let itemHistory = await context.makeRequest("Site.getHistory", {
            siteUuid: this.state.itemData.uuid,
            hours: hours || this.state.historyHours || 12,
            filters: filters.length === 0 ? null : filters
        });

            this.setState({ 
                historyHours: hours || this.state.historyHours,
                itemHistory: itemHistory.result || [],
                itemHistoryTime: new Date(),
                historyLoading: false
            });
    }

    async updateApiHistory() {
        this.setState({ historyLoading: true });
        let itemHistory = await context.makeRequest("Admin.getApiHistory", {
            uuid: this.state.itemData.uuid
        });
        //console.log("HIST", itemHistory);
        if (itemHistory.result)
            this.setState({ 
                apiHistory: itemHistory.result?.reverse() || []
            });
    }

    async updateWeather(force=false) {
        let weatherData = await context.makeRequest("Site.getWeather", { siteUuid: this.state.itemData.uuid, force: force });
        //console.log("HIST", itemHistory);
        if (weatherData.result)
            this.setState({
                weather: weatherData.result || {}
            });
    }

    async updateMetrics(hours) {
        if (!this.state.itemConfig?.Controllers || this.state.itemConfig?.Controllers.length === 0) {
            return;
        }
        let deviceUUID = this.state.itemConfig.Controllers[0].UUID;
        let itemMetrics = await context.makeRequest("Device.getMetrics", {
            uuid: deviceUUID,
            hours: hours || this.state.metricsHours
        });
        if (itemMetrics.result) {
            itemMetrics.result.EveryMinuteMetrics.map((item) => {
                item.ActualMemory = Math.round(item.ActualMemory * 10000) / 100;
                return item;
            });
            this.setState({ 
                metricsHours: hours || this.state.metricsHours,
                itemMetrics: itemMetrics.result,
                itemMetricsTime: new Date()
            });
        }
    }

    async updateStatus() {
        if (!this.state.itemData) {
            return;
        }
        let itemStatus = await context.makeRequest("Site.getStates", {
            site: {
                siteId: this.state.itemData.id
            }
        });
        //console.log(itemStatus.result);
        if (itemStatus.result && JSON.stringify(itemStatus?.result) !== JSON.stringify(this.state.itemStatus)) {
            this.setState({ 
                itemStatus: itemStatus.result
            });
        }
    }

    async updateData(uuid) {
        await super.updateData(uuid, async () => {
            const configs = await context.makeRequest("Site.getAllConfig", {
                siteId: this.state.itemData.id
            });

            if (configs.result) {
                this.setState({ 
                    allConfigs: configs.result,
                    itemConfig: configs.result.Config,
                    itemDesiredState: Array.isArray(configs.result.DesiredStates) ? configs.result.DesiredStates : [],
                    itemSchedule: configs.result.Schedule,
                    itemThemes: configs.result.Themes,
                    itemThemeMacros: configs.result.ThemeMacros,
                    heatingStats: configs.result.HeatingStats,
                    energyRates: configs.result.EnergyRates,
                    chemistry: configs.result.Chemistry,
                    palette: configs.result.Palette,
                    buttonMappings: configs.result.ButtonMappings,
                }, () => {
                    if (this.state.itemData && !this.state.itemMetrics) {
                        this.updateMetrics();
                        this.updateHistory();
                        //this.updateAlerts();
                        //this.updateNotes();
                        //this.updateBowHistory();
                        //this.updateApiHistory();
                        //this.updateWeather();
                        //console.log(this.state.itemData);
                    }
                });
            }
            this.updateStatus();
        })
    }

    async pingVpnAddress() {
        this.setState({
            vpnPing: []
        });
        let pingResults = [];
        for (let dev of this.state.itemData.devices) {
            let pingResp = await context.makeRequest("Admin.pingDevice", {
                uuid: dev.uuid
            });
            pingResults[dev.uuid] = pingResp.result;
        }
        //console.log(pingResults);
        this.setState({
            vpnPing: pingResults
        });
    }

    getHistoryData(param = "Temperature", devices) {
        let graphData = {
            data: [],
            series: {},
            states: []
        };
        if (!devices)
            devices = this.state.itemConfig?.BodiesOfWater.map(body => body.UUID) || []
        this.state.itemHistory.forEach((line) => {
            if (devices && devices.indexOf(line.Device) === -1) {
                return;
            }
            if (line.Param === param) {
                if (!graphData.series[line.Device] && line.Status) {
                    let sourceController = this.state.itemConfig.Controllers.find((controller) => controller.UUID === line.Source);
                    let controlObj = this.state.itemConfig.Controls.find((control) => control.UUID === line.Control);
                    let deviceObj = this.state.itemConfig.Devices.find((dev) => dev.UUID === line.Device) ||
                                    this.state.itemConfig.BodiesOfWater.find((dev) => dev.UUID === line.Device);
                    graphData.series[line.Device] = {
                        color: this.colors[Object.keys(graphData.series).length],
                        yName: line.Device,
                        title: deviceObj?.Name || "UNKNOWN"
                    };
                    graphData.states.push(line);
                }
                let dataRow = {
                    time: line.time
                };
                dataRow[line.Device] = line.Status;
                if (line.Status !== 0)
                    graphData.data.push(dataRow);
            }
        });

        graphData.series = Object.values(graphData.series);

        return graphData;
    }

    async saveRecord() {
        let reqParams = { ...this.state.itemData };
        
        //console.log(reqParams);
        let itemData = await context.makeRequest("Site.setInfo", reqParams);
        if (!itemData.error) {
            alert("Success");
            this.updateData();
        } else 
            alert("Error saving: " + itemData.error.message)
    }

    selectMaintainerPushed() {
        this.extraElement = (
            <OrganizationFinder
                multiSelect={false}
                onSave={ (newMaintainer) => {
                    this.state.itemData.maintainer = newMaintainer[0];
                    this.state.itemData.maintainerId = newMaintainer[0].id;
                    this.extraElement = null;
                    this.setState({  });
                }}
                onClose={ () => {
                    this.extraElement = null;
                    this.setState({});
                }}
            />
        );
        this.setState({  });
    }
    
    async addNotePushed() {
        this.extraElement = (
            <Modal
                onHide={ () => {
                    this.extraElement = null;
                    this.setState({});
                }}
                centered={ true }
                scrollable={ true }
                backdrop={ 'static' } show={true}
                ref={ this.dialogRef }
                size={'xl'}
            >
                <Modal.Header closeButton>
                    <Modal.Title>Add Note</Modal.Title>
                </Modal.Header>

                <Modal.Body style={{ flexDirection: 'row' }}>
                    <textarea 
                        style={{ width: '100%', height: '300px' }} 
                        defaultValue={ "" } 
                        ref={ this.newNoteRef }
                    />
                </Modal.Body>

                <Modal.Footer>
                    <Button variant="secondary"
                        onClick={ () => {
                            this.extraElement = null;
                            this.setState({});
                        } }
                    >Close</Button>
                    <Button variant="primary"
                        onClick={ async () => {
                            let noteRes = await context.makeRequest("Admin.setNote", {
                                siteId: this.state.itemData.id,
                                message: this.newNoteRef.current?.value
                            });
                            this.extraElement = null;
                            this.setState({});
                            this.updateNotes();
                        } }
                    >Save</Button>
                </Modal.Footer>
            </Modal>
        );
        this.setState({  });
    }

    async showWeatherPushed() {
        this.extraElement = (
            <Modal
                onHide={ () => {
                    this.extraElement = null;
                    this.setState({});
                }}
                centered={ true }
                scrollable={ true }
                backdrop={ 'static' } show={true}
                ref={ this.dialogRef }
                size={'xl'}
            >
                <Modal.Header closeButton>
                    <Modal.Title>Weather Details</Modal.Title>
                </Modal.Header>

                <Modal.Body style={{ flexDirection: 'row' }}>
                    <pre>
                        { JSON.stringify(this.state.weather, null, 2) }
                    </pre>
                </Modal.Body>

                <Modal.Footer>
                    <Button variant="secondary"
                        onClick={ () => {
                            this.extraElement = null;
                            this.setState({});
                        } }
                    >Close</Button>
                </Modal.Footer>
            </Modal>
        );
        this.setState({  });
    }

    async associateRecord() {
        this.extraElement = (
            <DeviceFinder
                multiSelect={ false }
                unassigned={ true }
                onSave={ async (newItem) => {
                    let result = await context.makeRequest("Device.setInfo", {
                        uuid: newItem[0].uuid,
                        siteId: this.state.itemData.id
                    });
                    this.extraElement = null;
                    this.updateData();
                }}
                onClose={ () => {
                    this.extraElement = null;
                    this.setState({});
                }}
            />
        );
        this.setState({  });
    }

    selectOwnerPushed() {
        this.extraElement = (
            <UserFinder
                multiSelect={false}
                onSave={ (newOwner) => {
                    this.state.itemData.owner = newOwner[0];
                    this.state.itemData.ownerId = newOwner[0].id;
                    this.extraElement = null;
                    this.setState({  });
                }}
                onClose={ () => {
                    this.extraElement = null;
                    this.setState({});
                }}
            ></UserFinder>
        );
        this.setState({  });
    }

    showConfigHistory(fileName = null) {
        //console.log("showConfigHistory", fileName);
        this.extraElement = (
            <Modal
                centered
                dialogClassName="wideDialog"
                show={ true }
                backdrop="static"
                scrollable={ true }
                onHide={ () => { this.extraElement = null; this.setState({}); } }
            >
                <Modal.Header closeButton >
                    <Modal.Title>Config history</Modal.Title>
                </Modal.Header>
                <Modal.Body>
                    <ConfigHistory
                        site={this.state.itemData}
                        fileName={ fileName }
                    />
                </Modal.Body>
                <Modal.Footer>
                    <Button variant="secondary" onClick={ () => { this.extraElement = null; this.setState({}); }}>Close</Button>
                </Modal.Footer>
            </Modal>
        );
        this.setState({});
    }

    render() { 
        if (this.checkload() !== true) {
            return this.checkload();
        }
        let bodyiesAndAmbientTemp = this.state.itemConfig?.BodiesOfWater.map(body => body.UUID) || [];
        if (this.state.itemConfig?.Ambient.Temperature) {
            bodyiesAndAmbientTemp.push(this.state.itemConfig?.Ambient.Temperature);
        }
        let bodyTempData = this.getHistoryData("Temperature", bodyiesAndAmbientTemp);
        //let sensorTempData = this.getHistoryData("Temperature", this.state.itemConfig?.Devices.filter(dev => dev.DeviceType === "Thermistor").map(dev => dev.UUID) || []);
        let phData = this.getHistoryData("PH");
        let orpData = this.getHistoryData("ORP");
        let saltData = this.getHistoryData("SaltLevel");

        return (
            <div style={{ flexDirection: 'row', display: 'flex', height: '100%', overflow: 'hidden' }}>
                <div style={{ width: 300, marginRight: 20 }}>
                    <Card style={{ marginBottom: 20 }}>
                        <Card.Body>
                            <Card.Title>{ Locale.gettext("Site Info") }</Card.Title>
                            { 
                                (
                                    <div>
                                        <div>
                                            <b>{ Locale.gettext("Name") }: </b><br />
                                            { this.state.itemData?.name }
                                        </div>
                                        <div>
                                            <b>{ Locale.gettext("Address") }: </b><br />
                                            { this.state.itemData?.address }<br/>
                                            { this.state.itemData?.city }, { this.state.itemData?.state } { this.state.itemData?.zip }<br />
                                            { this.state.itemData?.country }
                                        </div>
                                        <div>
                                            <b>{ Locale.gettext("Attendants") }: </b>
                                            { this.state.itemData?.devices.length }
                                        </div>
                                        <div>
                                            <b>{ Locale.gettext("Version") }: </b>
                                            { this.state.itemData.devices.length > 0 ? this.state.itemData.devices[0].versionName : Locale.gettext("N/A") }
                                        </div>
                                        <div>
                                            <b>{ Locale.gettext("Mode") }: </b>
                                            { this.state.itemStatus?.find(st => st.name === "Mode")?.state || "-" }
                                        </div>
                                        <div>
                                            <b>{ Locale.gettext("Connection") }: </b>
                                            { this.state.itemData.online ? 
                                                ( <span style={{ color: 'green' }} >{ Locale.gettext("Online") }</span> ) : 
                                                ( <span style={{ color: 'red' }} >{ Locale.gettext("Offline") }</span> )
                                            }
                                        </div>
                                        { this.state.itemData.online ? null : (
                                            <div>
                                                <b>{ Locale.gettext("Last Online") }: </b>
                                                { this.state.itemData?.lastSeen ? Locale.formatDateTime(this.state.itemData?.lastSeen) : ">90 days" }
                                            </div>)
                                        }
                                        <a 
                                            href={ "https://www.google.com/maps/search/?api=1&query=" + this.state.itemData.latitude + "," + this.state.itemData.longitude + "" } 
                                            target="googlemaps"
                                        >
                                            { Locale.gettext("Show on Google Maps") }
                                        </a>
                                    </div>
                                )
                            }
                        </Card.Body>
                    </Card>
                    <Card>
                        <Card.Body>
                            <Card.Title>{ Locale.gettext("Owner Info") }</Card.Title>
                            { this.state.itemData?.owner ?
                                (
                                    <div>
                                        <div>
                                            <b>{ Locale.gettext("Name") }: </b><br />
                                            { this.state.itemData?.owner?.firstName } { this.state.itemData?.owner?.lastName }
                                        </div>
                                        <div>
                                            <b>{ Locale.gettext("Email") }: </b><br />
                                            { this.state.itemData?.owner?.email ? (
                                              <a href={`mailto:${ this.state.itemData.owner.email.trim() }`}>
                                                { this.state.itemData.owner.email }
                                              </a>) : null }
                                        </div>
                                        { this.state.itemData?.owner?.phone ? (
                                            <div>
                                                <b>{ Locale.gettext("Phone") }: </b><br />
                                                <a href={`tel:${ this.state.itemData.owner.phone.trim() }`}>{ this.state.itemData.owner.phone }</a>
                                            </div> 
                                        ) : null }
                                        <div>
                                            <b>{ Locale.gettext("Address") }: </b><br />
                                            { this.state.itemData?.owner?.address }<br />
                                            { this.state.itemData?.owner?.city ? this.state.itemData?.owner?.city.trim() + ", " : null } 
                                            { this.state.itemData?.owner?.state }
                                            { this.state.itemData?.owner?.zip ? ", " + this.state.itemData?.owner?.zip : null }<br />
                                            { this.state.itemData?.owner?.country }
                                        </div>
                                    </div>
                                ) : 
                                Locale.gettext("This site does not have an owner assigned.  Please call Poolside.") }
                        </Card.Body>
                    </Card>
                </div>
                <div style={{ flex: 1, overflow: 'hidden' }}>
                    <Tabs 
                        id="site-tabs" 
                        defaultActiveKey={ this.state.pathParams.tab || "Alerts"}
                        onSelect={(k) => {
                            let parts = document.location.hash.toString().split("/");
                            parts[3] = k;
                            delete parts[4];
                            context.navigate(parts.join("/"));
                        }}
                    >
                        <Tab 
                            eventKey="Alerts" title={ Locale.gettext("Alerts") } key="Alerts" 
                            style={{ height: '100%', width: '100%' }}
                        >
                            <AlertList
                                site={ this.state.itemData }
                                config={ this.state.allConfigs || {} }
                            />
                        </Tab>
                        <Tab 
                            eventKey="History" title={ Locale.gettext("History") } key="History" 
                            style={{ height: '100%', width: '100%' }}
                        >
                            <HistoryList
                                site={ this.state.itemData }
                                config={ this.state.itemConfig || {} }
                                allConfigs={ this.state.allConfigs || {} }
                            />
                        </Tab>
                        <Tab 
                            eventKey="Flows" title={ Locale.gettext("Flows") } key="Flows" 
                            style={{ height: '100%', width: '100%', overflow: 'hidden' }}
                        >
                            <div className="flowCardHolder">
                                    { this.state.itemConfig?.Flows ? this.state.itemConfig.Flows.map((flow) => (
                                        <Flow 
                                            key={flow.UUID} 
                                            graph={flow} 
                                            height={ 600 }
                                            siteConfig={this.state.itemConfig} siteStatus={this.state.itemStatus}
                                        />
                                    )) : Locale.gettext("No flows found") }
                            </div>
                        </Tab>
                        <Tab 
                            eventKey="Temperature" title={ Locale.gettext("Temperature") } key="Temperature" 
                            style={{ height: '100%', width: '100%' }}
                        >
                            <HistoryTimeRange 
                                valueHours={ this.state.historyHours }
                                onChange={ (val) => {
                                    this.setState({ historyHours: val.valueHours }, 
                                        () => {
                                            this.updateHistory();
                                        });
                                }}
                            />
                            <LineGraph 
                                width="700" height="300" 
                                data={ bodyTempData.data }
                                series={ bodyTempData.series }
                                key="Body Temperature"
                            />
                        </Tab>
                        <Tab 
                            eventKey="WaterQuality" title={ Locale.gettext("Water Quality") } key="WaterQuality" 
                            style={{ height: '100%', width: '100%' }}
                        >
                            <HistoryTimeRange 
                                valueHours={ this.state.historyHours }
                                onChange={ (val) => {
                                    this.setState({ historyHours: val.valueHours }, 
                                        () => {
                                            this.updateHistory();
                                        });
                                }}
                                detailScreen={ this }
                            />
                            <LineGraph 
                                title={ Locale.gettext("PH") }
                                width="700" height="300" 
                                data={ phData.data }
                                series={ phData.series }
                                key="PH"
                                defaultBounds={{ x: [6, 10] }}
                            />
                            <LineGraph
                                title={ Locale.gettext("ORP") }
                                width="700" height="300" 
                                data={ orpData.data }
                                series={ orpData.series }
                                key="ORP"
                                defaultBounds={{ x: [0, 1000] }}
                            />
                            <LineGraph
                                title={ Locale.gettext("Salt") }
                                width="700" height="300"
                                data={ saltData.data }
                                series={ saltData.series }
                                key="SALT"
                                defaultBounds={{ y: [0, 6000] }}
                            />
                        </Tab>
                        <Tab 
                            eventKey="Filtering" title={ Locale.gettext("Filtering") } key="Filtering" 
                            style={{ height: '100%', width: '100%' }}
                        >
                            <HistoryTimeRange 
                                valueHours={ this.state.metricsHours }
                                onChange={ (val) => {
                                    this.setState({ metricsHours: val.valueHours }, 
                                        () => {
                                            this.updateMetrics();
                                        });
                                }}
                            />
                            <LineGraph 
                                width="700"
                                height="250" 
                                data={ this.state.itemMetrics ? this.state.itemMetrics.EveryMinuteBodyOfWater : [] }
                                series={[ 
                                    {
                                        color: "green",
                                        yName: "VolumeFiltered",
                                        yMin: 0
                                    }
                                ]}
                                key={ "VolumeFilteredGraph" }
                            />
                        </Tab>
                    </Tabs>
                </div>
            </div>
        );
    }
}